export const getWorkspaceServiceApiUrl = () => '/api/workspace-service';
